module.exports = __webpack_public_path__ + "static/media/destinationLeft.cc9ee1ad.svg";